import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
// import { DashboardComponent } from './dashboard/dashboard.component';
import { HelicoptersComponent } from "./helicopters/helicopters.component";
import { HoldItemListTableComponent } from "./hold-item-list/hold-item-list-table/hold-item-list-table.component";
import { HoldItemListComponent } from "./hold-item-list/hold-item-list.component";
import { UpdateHtlBlockComponent } from "./htl/htl-blocks/update-htl-block/update-htl-block.component";
import { HtlComponent } from "./htl/htl.component";
import { NextDueMaintenanceComponent } from "./next-due-maintenance/next-due-maintenance.component";
import { LoginComponent } from "./login/login.component";
import { PassengersComponent } from "./passengers/passengers.component";
import { HtlPdfViewerComponent } from "./public-layout/htl-pdf-viewer/htl-pdf-viewer.component";
import { PublicLayoutComponent } from "./public-layout/public-layout.component";
import { AuthGuard } from "./shared/_helpers/auth.guard";
import { UpdateFlightComponent } from "./update-flight/update-flight.component";
import { NextDueMaintenanceTableComponent } from "./next-due-maintenance/next-due-maintenance-table/next-due-maintenance-table.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { FlightsComponent } from "./flights/flights.component";
import { FlightsTableComponent } from "./flights/flights-table/flights-table.component";
import { AppLayoutComponent } from "./app-layout/app-layout.component";
import { StatisticPilotHoursComponent } from "./statistic-pilot-hours/statistic-pilot-hours.component";
import { UpdateProfileComponent } from "./profile/update-profile/update-profile.component";
import { ExportDataComponent } from "./export-data/export-data.component";
import { EditQtbComponent } from "./edit-qtb/edit-qtb.component";
import { AppConfigComponent } from "./app-config/app-config.component";
import { environment } from "../environments/environment";
import { ExternalRedirectComponent } from "./external-redirect.component";
import { DailyChecksComponent } from "./daily-checks/daily-checks.component";
import { AircraftActivityComponent } from "./aircraft-activity/aircraft-activity.component";
import { PilotActivityComponent } from "./pilot-activity/pilot-activity.component";
import { CreatePasswordComponent } from "./create-password/create-password.component";
import { AIPageComponent } from "./ai-page/ai-page.component";
import { Flights2Component } from "./flights2/flights2.component";

const routes: Routes = [
    { path: "", redirectTo: "/flights", pathMatch: "full" },
    {
        path: "",
        component: AppLayoutComponent,
        children: [
            { path: "dashboard", canActivate: [AuthGuard], component: DashboardComponent },
            { path: "passengers", canActivate: [AuthGuard], component: PassengersComponent },
            { path: "flight/update/:flightId", canActivate: [AuthGuard], component: UpdateFlightComponent },
            { path: "aircrafts", canActivate: [AuthGuard], component: HelicoptersComponent },
            { path: "flights2", canActivate: [AuthGuard], component: Flights2Component },
            { path: "atl", canActivate: [AuthGuard], component: HtlComponent },
            {
                path: "flights",
                canActivate: [AuthGuard],
                component: FlightsComponent,
                children: [{ path: "", canActivate: [AuthGuard], component: FlightsTableComponent }],
            },
            { path: ":registrationMark/blocks/update/:blockId", canActivate: [AuthGuard], component: UpdateHtlBlockComponent },
            {
                path: "hold-item-list",
                canActivate: [AuthGuard],
                component: HoldItemListComponent,
                children: [{ path: "list/:registrationMark", canActivate: [AuthGuard], component: HoldItemListTableComponent }],
            },
            {
                path: "next-due-maintenances",
                canActivate: [AuthGuard],
                component: NextDueMaintenanceComponent,
                children: [{ path: "list/:registrationMark", canActivate: [AuthGuard], component: NextDueMaintenanceTableComponent }],
            },
            { path: "daily-checks", canActivate: [AuthGuard], component: DailyChecksComponent },
            { path: "statistic-pilot-hours", canActivate: [AuthGuard], component: StatisticPilotHoursComponent },
            { path: "export", canActivate: [AuthGuard], component: ExportDataComponent },
            { path: "profile", canActivate: [AuthGuard], component: UpdateProfileComponent },
            { path: "edit-qtb", canActivate: [AuthGuard], component: EditQtbComponent },
            { path: "edit-qtb/:helicopterId/:blockId/:documentId", canActivate: [AuthGuard], component: EditQtbComponent },
            { path: "app", canActivate: [AuthGuard], component: AppConfigComponent },
            { path: "aircraft-activity", canActivate: [AuthGuard], component: AircraftActivityComponent },
            { path: "pilot-activity", canActivate: [AuthGuard], component: PilotActivityComponent },
            { path: "ai", canActivate: [AuthGuard], component: AIPageComponent },
        ],
    },
    { path: "login", component: LoginComponent },
    { path: "create-password", canActivate: [AuthGuard], component: CreatePasswordComponent },
    {
        path: "public",
        component: PublicLayoutComponent,
        children: [{ path: "htl-viewer/:helicopterId", component: HtlPdfViewerComponent }],
    },
];

if (environment.production) {
    routes.push({
        path: "android",
        component: ExternalRedirectComponent,
        data: { externalUrl: "https://play.google.com/store/apps/details?id=com.avioblue.aircrafttechlog" },
        pathMatch: "full",
    });
    routes.push({
        path: "android/offline",
        component: ExternalRedirectComponent,
        data: { externalUrl: "https://play.google.com/store/apps/details?id=com.rrsolutions.helicopterlog" },
        pathMatch: "full",
    });
    routes.push({ path: "ios", component: ExternalRedirectComponent, data: { externalUrl: "https://apps.apple.com/us/app/atl-app-avioblue/id6737056081" }, pathMatch: "full" });
    routes.push({
        path: "ios/offline",
        component: ExternalRedirectComponent,
        data: { externalUrl: "https://apps.apple.com/us/app/helicopterlog/id1554238396" },
        pathMatch: "full",
    });
    routes.push({
        path: "android-maintenance",
        component: ExternalRedirectComponent,
        data: { externalUrl: "https://play.google.com/store/apps/details?id=com.avioblue.aircrafttechlog.maintenance" },
        pathMatch: "full",
    });
    routes.push({
        path: "ios-maintenance",
        component: ExternalRedirectComponent,
        data: { externalUrl: "https://apps.apple.com/us/app/atl-maintenance-app-avioblue/id6737182173" },
        pathMatch: "full",
    });
} else {
    routes.push({ path: "android", component: ExternalRedirectComponent, data: { externalUrl: "https://play.google.com/" }, pathMatch: "full" });
    routes.push({ path: "ios", component: ExternalRedirectComponent, data: { externalUrl: "https://testflight.apple.com/join/6636546817" }, pathMatch: "full" });
    routes.push({ path: "android-maintenance", component: ExternalRedirectComponent, data: { externalUrl: "https://play.google.com/" }, pathMatch: "full" });
    routes.push({ path: "ios-maintenance", component: ExternalRedirectComponent, data: { externalUrl: "https://testflight.apple.com/join/6698894542" }, pathMatch: "full" });
}

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
